import request from "@/util/request";

export default {

  count: function() {
    return request({
      url: "/user/doctor/cart/count",
      method: "get"
    });
  },

  queryByUser: function() {
    return request({
      url: "/user/doctor/cart/queryByUser",
      method: "get"
    });
  },

  add: function(params) {
    return request({
      url: "/user/doctor/cart/add",
      method: "post",
      data: params
    });
  },

  remove: function(params) {
    return request({
      url: "/user/doctor/cart",
      method: "delete",
      data: params
    });
  }

};
